import { ensureArray } from "@thi.ng/arrays";
import { isArray, isString } from "@thi.ng/checks";
import { concat } from "./concat";
export function dup(x) {
    return isString(x)
        ? x + x
        : isArray(x)
            ? x.concat(x)
            : ((x = ensureArray(x)), concat(x, x));
}
